module.exports = __webpack_public_path__ + "static/media/Institutional Innovation Cell.9375a56a.pdf";